/* eslint-disable */
const types = {
  // Success Types
  GET_PLATE_VALIDATE_PERMITS_SUCCESS: "GET_PLATE_VALIDATE_PERMITS_SUCCESS",
  UPDATE_PERMIT_STATUS_SUCCESS: "UPDATE_PERMIT_STATUS_SUCCESS",
  DELETE_PERMIT_SUCCESS: "DELETE_PERMIT_SUCCESS",
  DEACTIVATE_PERMITS_ON_LOT_DELETE_SUCCESS: "DEACTIVATE_PERMITS_ON_LOT_DELETE_SUCCESS",
  DELETE_PLATE_VALIDATE_DISCOUNT_SUCCESS: "DELETE_PLATE_VALIDATE_DISCOUNT_SUCCESS",

  // Failure Types (to be used in reducers for handling specific error states if needed)
  GET_PLATE_VALIDATE_PERMITS_FAILURE: "GET_PLATE_VALIDATE_PERMITS_FAILURE",
  UPDATE_PERMIT_STATUS_FAILURE: "UPDATE_PERMIT_STATUS_FAILURE",
  DELETE_PERMIT_FAILURE: "DELETE_PERMIT_FAILURE",
  DEACTIVATE_PERMITS_ON_LOT_DELETE_FAILURE: "DEACTIVATE_PERMITS_ON_LOT_DELETE_FAILURE",
  DELETE_PLATE_VALIDATE_DISCOUNT_FAILURE: "DELETE_PLATE_VALIDATE_DISCOUNT_FAILURE",
};

export default types;